export const BlockStoreList =
    [
        'audiencePathing',
        'bloodDrawFinder',
        'carousel',
        'decisionTree',
        'dualOptionCards',
        'dynamicForm',
        'faq',
        'featuredDataPoint',
        'glossary',
        'providerFinder',
        'resourcesGrid',
        'signupForm'
    ]
